import { setStorageItem } from '../../../helpers/storage';
import { TOKEN_STORAGE_KEY } from '../constants';

export const setLiveRamp = (envelope: string) =>
  setStorageItem(TOKEN_STORAGE_KEY, JSON.stringify({ envelope, timestamp: Date.now() }));
